import type { VoidFunctionComponent } from 'react';

import Button from '../../../../../../../../../../generic/Button/Button';
import TooltipButton from '../../../../../../../../../../generic/Button/TooltipButton';
import { ICON_SIZE } from '../../../../../../../../../../generic/Icon/icon-constants';
import { IconText } from '../../../../../../../../../../generic/Icon/index';
import type { ButtonType } from '../../../../../../../../../../generic/Button/button-constants';
import type { IconClassName } from '../../../../../../../../../../generic/Icon';

import styles from './ProjectRowButton.module.less';

type Props = {
  buttonType: ButtonType;
  icon: IconClassName;
  text: string;
  onClick: () => void;
  tooltip?: string;
  isDisabled?: boolean;
};

const ButtonText: VoidFunctionComponent<{ icon: IconClassName; text: string }> = (props) => (
  <div className={styles.buttonText}>
    <IconText icon={props.icon} size={ICON_SIZE.LG} text={props.text} />
  </div>
);

const ProjectRowButton: VoidFunctionComponent<Props> = (props) => {
  return props.tooltip && props.isDisabled ? (
    <TooltipButton
      id="project-row-button"
      onClick={props.onClick}
      type={props.buttonType}
      tooltip={props.tooltip}
      isDisabled={props.isDisabled}
    >
      <ButtonText icon={props.icon} text={props.text} />
    </TooltipButton>
  ) : (
    <Button onClick={props.onClick} type={props.buttonType} isDisabled={props.isDisabled}>
      <ButtonText icon={props.icon} text={props.text} />
    </Button>
  );
};

export default ProjectRowButton;
